import { useEffect, useState } from "react";

export async function fetchLatestAmendmentNotice() {
  const response = await fetch("/api/onto/amendment-notices/latest");
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const data = await response.json();
  return data?.available ? data : null;
}

export async function fetchRecentAmendmentNotices(limit = 10) {
  const safeLimit = Math.max(1, Math.min(Number(limit) || 10, 30));
  const response = await fetch(`/api/onto/amendment-notices?limit=${safeLimit}`);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const data = await response.json();
  return Array.isArray(data?.items) ? data.items : [];
}

export function useLatestAmendmentNotice() {
  const [notice, setNotice] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchLatestAmendmentNotice()
      .then((data) => alive && setNotice(data))
      .catch(() => {}); // 부가 피드 실패가 메인 화면을 가리지 않게 조용히 열화한다.
    return () => { alive = false; };
  }, []);
  return notice;
}

export function amendmentNoticeToNewsItem(notice) {
  if (!notice) return null;
  return {
    id: notice.id,
    date: notice.gosiDate,
    type: notice.type || "품목분류 변경고시",
    title: notice.title,
    content: notice.content,
    url: notice.sourceUrl,
    sourcePdfUrl: notice.sourcePdfUrl,
    changedItemCount: notice.changedItemCount,
    gosiNo: notice.gosiNo,
    items: Array.isArray(notice.items) ? notice.items : [],
    _loginhs: true,
    _amendment: true,
  };
}

export function openNewsPage() {
  window.history.pushState({}, "", "/?page=news");
  window.dispatchEvent(new PopStateEvent("popstate"));
}
